import axios from "axios";

function showCharge(user_id, obj) {
  const currentUserToken = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/api/user/stripe/exclusive-show-charge/${user_id}`;
  return axios
    .post(url, obj, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUserToken}`,
        source: "front",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return []; // Return an empty array or handle the error as needed
    });
}
export default showCharge;
